import type { RacerProgress } from './types'

export function advanceOrderedProgress(
  current: RacerProgress,
  checkpoint: number,
  now: number,
  totalLaps: number,
  checkpointCount: number,
): RacerProgress {
  if (current.recordStatus !== 'racing') return current
  const validCheckpointCount = Number.isSafeInteger(checkpointCount) && checkpointCount >= 2
  const validTotalLaps = Number.isSafeInteger(totalLaps) && totalLaps > 0
  if (!validCheckpointCount || !validTotalLaps) return current

  const validCheckpoint = (value: number) => Number.isSafeInteger(value) && value >= 0 && value < checkpointCount
  const validLap = Number.isSafeInteger(current.lap) && current.lap >= 0 && current.lap < totalLaps
  const validLapStartedAt = Number.isFinite(current.lapStartedAt) && current.lapStartedAt >= 0
  const validBestLap = current.bestLap === null || (Number.isFinite(current.bestLap) && current.bestLap >= 0)
  if (
    !validCheckpoint(checkpoint) ||
    !validCheckpoint(current.lastCheckpoint) ||
    !validCheckpoint(current.nextCheckpoint) ||
    current.nextCheckpoint !== (current.lastCheckpoint + 1) % checkpointCount ||
    !validLap ||
    current.finishedAt !== null ||
    !validLapStartedAt ||
    !validBestLap ||
    !Number.isFinite(now) ||
    now < current.lapStartedAt ||
    checkpoint !== current.nextCheckpoint
  ) {
    return current
  }

  const nextCheckpoint = (checkpoint + 1) % checkpointCount
  if (checkpoint !== 0) return { ...current, lastCheckpoint: checkpoint, nextCheckpoint }

  const lap = current.lap + 1
  const lapTime = now - current.lapStartedAt
  const bestLap = current.bestLap === null ? lapTime : Math.min(current.bestLap, lapTime)
  const finished = lap >= totalLaps
  return {
    ...current,
    lap,
    lastCheckpoint: checkpoint,
    nextCheckpoint,
    lapStartedAt: now,
    bestLap,
    finishedAt: finished ? now : current.finishedAt,
    recordStatus: finished ? 'finished' : current.recordStatus,
  }
}
